import React from 'react';

import { Link as MuiLink } from '@material-ui/core';

const ExternalLink = ({ label, link, ...props }) => (
  <MuiLink href={link} target="_blank" rel="noopener" {...props}>{label}</MuiLink>
);

export default ExternalLink;
